import React from 'react';
import { SaveOutlined } from '@ant-design/icons';
import CenterModal from '../CenterModal';
import Button from '../Button';
import './UnsavedChangesModal.scss';

interface UnsavedChangesModalProps {
  onClose: () => void;
  onDiscard: () => void;
  onSaveChanges: () => void;
  title?: string;
  message?: string;
  discardText?: string;
  saveText?: string;
  loading?: boolean;
}

const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({
  onClose,
  onDiscard,
  onSaveChanges,
  title = 'Unsaved changes',
  message = 'Do you want to save or discard changes?',
  discardText = 'Discard',
  saveText = 'Save changes',
  loading = false,
}) => {
  const footer = (
    <div className="unsaved-changes-modal__footer">
      <Button
        theme="secondary"
        onClick={onDiscard}
        disabled={loading}
        className="unsaved-changes-modal__footer-button unsaved-changes-modal__footer-button--discard"
      >
        {discardText}
      </Button>
      <Button
        theme="primary"
        onClick={onSaveChanges}
        loading={loading}
        className="unsaved-changes-modal__footer-button"
      >
        {saveText}
      </Button>
    </div>
  );

  return (
    <CenterModal
      open={true}
      onClose={onClose}
      title={''}
      width={400}
      footer={footer}
      closable={true}
      maskClosable={!loading}
      className="unsaved-changes-modal"
    >
      <div className="unsaved-changes-modal__content">
        {/* Background pattern */}
        <div className="unsaved-changes-modal__background-pattern" />

        {/* Icon container */}
        <div className="unsaved-changes-modal__icon-container">
          <SaveOutlined className="unsaved-changes-modal__icon" />
        </div>

        <h3 className="unsaved-changes-modal__title">{title}</h3>

        <p className="unsaved-changes-modal__message">{message}</p>
      </div>
    </CenterModal>
  );
};

export default UnsavedChangesModal;

